import React, { useState } from 'react';
import Chart from "react-apexcharts";
import '../statistics-page/Statistics.css'

function Charts() {
    const [chartState, setChartState] = useState({
        options: {
            chart: {
                id: "basic-bar"
            },
            xaxis: {
                categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
            },
            yaxis: {
                labels: {
                    show: false // إخفاء الترقيم العمودي
                }
            },
            xaxis: {
                labels: {
                    show: false // إخفاء الترقيم الأفقي
                },
                axisTicks: {
                    show: false // إخفاء الخطوط الأفقية
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '30%',
                    colors: {
                        ranges: [{
                            from: 0, // قيمة من
                            to: 30, // قيمة إلى
                            color: '#ffbc01' // لون للعمود الأول
                        }, {
                            from: 31, // قيمة من
                            to: 60, // قيمة إلى
                            color: '#1dd21d' // لون للعمود الثاني
                        }, {
                            from: 61, // قيمة من
                            to: 100, // قيمة إلى
                            color: '#7367f0' // لون للعمود الثالث
                        }]
                    },
                }
            },
            grid: {
                show: false // إخفاء خطوط الشبكة (grid lines)
            }
        },
        series: [
            {
                name: "series-1",
                data: [30, 40, 45, 49, 60, 70]
            }
        ]
    });
    const [chartState1, setChartState1] = useState({
        options: {
            colors: ['#ffbc01', '#1dd21d', '#7367f0'], // تحديد ألوان مخصصة للحلقات
        },
        series: [44, 55, 41],
        labels: ['A', 'B', 'C', 'D', 'E']
    })
    return (
        <div className="chart-container margin_main">
            <div className='chart_container_top shadow_main' >
                <div className='chart_container_top_left' >
                    <div className='chart_container_top_static' >
                        <div>
                            <p className='card_statistic_num' >2.7k</p>
                            <p className='card_statistic_p'>Avg Sessions</p>
                            <br></br>
                            <p className='card_statistic_p' ><span className='num_green'>+5.2% </span> vs last 7 days</p>
                        </div>
                        <button className='btn_chart' >View Details</button>
                    </div>
                    <div className='chart_container_top_chart' >
                        <Chart
                            options={chartState.options}
                            series={chartState.series}
                            type="bar"
                            width="100%"
                            height='270'
                        />
                    </div>
                </div>
            </div>
            <div className='chart_container_top_right shadow_main' >
                <div className='chart_container_top_right_info' >
                    <p className='title_chart_right' >Support Tracker</p>
                    <p className='num_chart_right' >163</p>
                    <p className='card_statistic_p'>Tickets</p>
                </div>
                <div className='div_chart_circle' ><Chart options={chartState1.options} series={chartState1.series} type="donut" width="290" /></div>
                <div className='Line_chart_container_top_right' >
                    <div>
                        <p className='card_statistic_p'>New Tickets</p>
                        <p className='card_statistic_num'>29</p>
                    </div>
                    <div>
                        <p className='card_statistic_p'>Open Tickets</p>
                        <p className='card_statistic_num'>63</p>
                    </div>
                    <div>
                        <p className='card_statistic_p'>Response Time</p>
                        <p className='card_statistic_num'>1d</p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Charts;